import React from 'react';
import { SvgIcon } from '@mui/material';
const SvgCreditCard = (props) => (
  <SvgIcon {...props} title="CreditCard">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 44 34"
      fill="none"
      {...props}
    >
      <path
        d="M39.346 2.281H4.94A3.128 3.128 0 0 0 1.812 5.41v23.459c0 1.727 1.4 3.128 3.128 3.128h34.406c1.728 0 3.128-1.4 3.128-3.128V5.409c0-1.727-1.4-3.128-3.128-3.128ZM1.813 13.234h40.661M29.965 24.172h4.692"
        stroke="#017163"
        strokeWidth={3}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);
export default SvgCreditCard;
